@if ((dark$ | async) === true) {
<button class="nav-link"
    (click)="toggle()"
    aria-label="Switch to dark mode">
    <fa-icon [icon]="faMoon" aria-hidden="true" />
</button>
} @else {
    <button class="nav-link"
    (click)="toggle()"
    aria-label="Switch to light mode">
    <fa-icon [icon]="faSun" aria-hidden="true" />
</button>
}
